import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import { fetchCollections } from '../../../redux/ducks/collections';

import NoSearchTermPage from './NoSearchTermPage';
import SearchItemPage from './SearchItemPage';
import CollectionsPage from './CollectionsPage';
import CategoryPage from './CategoryPage';
import SubCategoryPage from './SubCategoryPage';
import ItemPage from './ItemPage';
import EditItemPage from './EditItemPage';
import NewItemPage from './NewItemPage';
import Loading from '../../common/Loading';

class CollectionsRootPage extends React.Component {
  componentDidMount() {
    const { fetched, getCollections } = this.props;

    if (!fetched) {
      getCollections();
    }
  }

  render() {
    const { isFetching, fetched } = this.props;

    if (isFetching || !fetched) {
      return <Loading />;
    }

    return (
      <Switch>
        <Route exact path="/collections/search/" component={NoSearchTermPage} />
        <Route path="/collections/search/:searchTerm" component={SearchItemPage} />
        <Route path="/collections/add" component={NewItemPage} />
        <Route path="/collections/edit/:itemId" component={EditItemPage} />
        <Route
          path="/collections/:category/:subcategoryType/:subcategory/:itemId"
          component={ItemPage}
        />
        <Route
          path="/collections/:category/:subcategoryType/:subcategory"
          component={SubCategoryPage}
        />
        <Route path="/collections/:category" component={CategoryPage} />
        <Route path="/" component={CollectionsPage} />
      </Switch>
    );
  }
}

CollectionsRootPage.propTypes = {
  getCollections: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  fetched: PropTypes.oneOfType([PropTypes.bool, PropTypes.instanceOf(Date)]).isRequired,
};

function mapStateToProps(state) {
  const {
    collections: { isFetching, fetched },
  } = state;

  return {
    isFetching,
    fetched,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getCollections: () => {
      dispatch(fetchCollections());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionsRootPage);



// WEBPACK FOOTER //
// ./src/components/pages/collections/CollectionsRootPage.jsx